import script from "./_SpanInput.vue?vue&type=script&setup=true&lang=js"
export * from "./_SpanInput.vue?vue&type=script&setup=true&lang=js"

import "./_SpanInput.vue?vue&type=style&index=0&id=45ee5b83&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ee5b83"]])

export default __exports__